import { render, staticRenderFns } from "./products-viewer.vue?vue&type=template&id=74a1feeb&"
import script from "./products-viewer.vue?vue&type=script&lang=js&"
export * from "./products-viewer.vue?vue&type=script&lang=js&"
import style0 from "./products-viewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports